const productPurchaseOrderTypes = {
  FETCH_PRODUCT_DETAILS: 'FETCH_PRODUCT_DETAILS',
  FETCH_COMPANY_DETAILS: 'FETCH_COMPANY_DETAILS',
  FETCH_PO_TEMPLATE_DETAILS: 'FETCH_PO_TEMPLATE_DETAILS',
  CLEAR_PO_TEMPLATE_DETAILS: 'CLEAR_PO_TEMPLATE_DETAILS',
  FETCH_FILTERED_DEVELOPMENT_ORDERS: 'FETCH_FILTERED_DEVELOPMENT_ORDERS',
  CLEAR_FILTERED_DEVELOPMENT_ORDERS: 'CLEAR_FILTERED_DEVELOPMENT_ORDERS',
  FETCH_SUPPLIER_FACTORIES: 'FETCH_SUPPLIER_FACTORIES',
  CLEAR_SUPPLIER_FACTORIES: 'CLEAR_SUPPLIER_FACTORIES',
  CREATE_PURCHASE_ORDER_SUCCESS: 'CREATE_PURCHASE_ORDER_SUCCESS',
  UPDATE_PURCHASE_ORDER_SUCCESS: 'UPDATE_PURCHASE_ORDER_SUCCESS',
  DELETE_PURCHASE_ORDER_SUCCESS: 'DELETE_PURCHASE_ORDER_SUCCESS',
  BULK_DELETE_PURCHASE_ORDERS_SUCCESS: 'BULK_DELETE_PURCHASE_ORDERS_SUCCESS',
  FETCH_PURCHASE_ORDERS_LIST: 'FETCH_PURCHASE_ORDERS_LIST',
  APPEND_PURCHASE_ORDERS: 'APPEND_PURCHASE_ORDERS',
  FETCH_PURCHASE_ORDER_DETAILS: 'FETCH_PURCHASE_ORDER_DETAILS',
  // File operations
  UPLOAD_PO_FILE_SUCCESS: 'UPLOAD_PO_FILE_SUCCESS',
  FETCH_PO_FILES_LIST: 'FETCH_PO_FILES_LIST',
  FETCH_PO_FILE_DETAILS: 'FETCH_PO_FILE_DETAILS',
  UPDATE_PO_FILE_SUCCESS: 'UPDATE_PO_FILE_SUCCESS',
  DELETE_PO_FILE_SUCCESS: 'DELETE_PO_FILE_SUCCESS',
  BULK_DELETE_PO_FILES_SUCCESS: 'BULK_DELETE_PO_FILES_SUCCESS',
  // Old PO operations
  FETCH_OLD_PURCHASE_ORDERS: 'FETCH_OLD_PURCHASE_ORDERS',
  APPEND_OLD_PURCHASE_ORDERS: 'APPEND_OLD_PURCHASE_ORDERS',
  DELETE_OLD_PURCHASE_ORDER_SUCCESS: 'DELETE_OLD_PURCHASE_ORDER_SUCCESS',
  BULK_DELETE_OLD_PURCHASE_ORDERS_SUCCESS: 'BULK_DELETE_OLD_PURCHASE_ORDERS_SUCCESS',
  // PDF Download
  DOWNLOAD_PO_PDF: 'DOWNLOAD_PO_PDF',
  // Status Update
  UPDATE_PO_STATUS_SUCCESS: 'UPDATE_PO_STATUS_SUCCESS',
  // Logs and History
  FETCH_PO_LOGS_AND_HISTORY: 'FETCH_PO_LOGS_AND_HISTORY',
  FETCH_PO_LOG_BY_ID: 'FETCH_PO_LOG_BY_ID',
  FETCH_PO_LOG_DETAILS_BY_ID: 'FETCH_PO_LOG_DETAILS_BY_ID',
  // Clear all PO data
  CLEAR_ALL_PO_DATA: 'CLEAR_ALL_PO_DATA',
};

export default productPurchaseOrderTypes;
